/**
 * Created by admin on 2018/8/3.
 */
import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { Modal, DatePicker } from 'antd';
import './RoomMaintainModal.less';
import { Btn } from '../Widgets';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { MAINTAIN_STATUS } from '../../utils/constants';

class RoomMaintainModal extends PureComponent {
  static defaultProps = {
    visible: false
  };

  constructor() {
    super();
    this.state = {
      id: -1,
      maintainStatus: 0,
      startMaintainTime: moment().add(1,'minutes'),
      endMaintainTime: moment().add(1,'days').add(1,'minutes'),
    };
  }
  componentWillReceiveProps(nextProps) {
    const { visible: preVisible } = this.props;
    const { visible, currentRoomInfo } = nextProps;
    if (!preVisible && visible && currentRoomInfo.id) {
      const {id, startMaintainTime, endMaintainTime, maintainStatus } = currentRoomInfo;
      if(startMaintainTime && endMaintainTime) {
        this.setState({
          id,
          startMaintainTime: moment(startMaintainTime),
          endMaintainTime: moment(endMaintainTime),
          maintainStatus : maintainStatus
        });
      }
    }
  }
  render() {
    const { visible, intl } = this.props;
    return (
      <Modal
        destroyOnClose={true}
        visible={visible}
        onCancel={this.close}
        title={intl.formatMessage({ id: 'room_manage_repair' })}
        wrapClassName="room-maintain-wrapper modal-close-header"
        width={600}
        footer={
          <div className="edit-footer">
            <Btn onClick={this.close}>
              {intl.formatMessage({ id: 'modal_manage_btn_cancel' })}
            </Btn>
            <Btn primary onClick={this.save}>
              {intl.formatMessage({ id: 'modal_manage_btn_ok' })}
            </Btn>
            {MAINTAIN_STATUS.not_set !== this.state.maintainStatus && (
              <Btn ghost onClick={this.earlyEnd} style={{ 'marginLeft': '23px' }}>
                {intl.formatMessage({ id: 'modal_manage_btn_end' })}
              </Btn>)}
          </div>
        }
        closable
      >
        <div className="room-maintain">
          <div className="maintain-item">
            <span>{intl.formatMessage({ id: 'room_maintain_start_label' })}：</span>
            <span>
              <DatePicker
                value={this.state.startMaintainTime}
                showToday={false}
                showTime={{ defaultValue: moment('00:00', 'HH:mm'), format: 'HH:mm' }}
                format={"YYYY-MM-DD HH:mm"}
                placeholder={intl.formatMessage({id: 'room_maintain_start_pls'})}
                onChange={(value, dateStr) => {
                  this.setState({
                    startMaintainTime: value
                  })
                }}
              />
            </span>
          </div>
          <div className="maintain-item">
            <span>{intl.formatMessage({ id: 'room_maintain_end_label' })}：</span>
            <span>
              <DatePicker
                value={this.state.endMaintainTime}
                showToday={false}
                showTime={{ defaultValue: moment('00:00', 'HH:mm'), format: 'HH:mm' }}
                format={"YYYY-MM-DD HH:mm"}
                placeholder={intl.formatMessage({id: 'room_maintain_end_pls'})}
                onChange={(value, dateStr) => {
                  this.setState({
                    endMaintainTime: value
                  })
                }}
              />
            </span>
          </div>
        </div>
      </Modal>
    );
  }
  close = () => {
    this.setState({
      id: -1,
      maintainStatus: MAINTAIN_STATUS.not_set,
      startMaintainTime: moment().add(1,'minutes'),
      endMaintainTime: moment().add(1,'days').add(1,'minutes'),
    });
    const { onClose } = this.props;
    onClose && onClose();
  };
  save = () => {
    if(!this.state.startMaintainTime){
      Modal.error({ content: this.props.intl.formatMessage({ id: 'room_maintain_start_empty' }) });
      return;
    }
    if(!this.state.endMaintainTime){
      Modal.error({ content: this.props.intl.formatMessage({ id: 'room_maintain_end_empty' }) });
      return;
    }
    const timeNow = moment();
    if(moment(this.state.startMaintainTime).isBefore(timeNow)){
      Modal.error({ content: this.props.intl.formatMessage({ id: 'room_maintain_start_less_than_now' }) });
      return;
    }
    if(!moment(this.state.startMaintainTime).isBefore(moment(this.state.endMaintainTime))){
      Modal.error({ content: this.props.intl.formatMessage({ id: 'room_maintain_end_less_than_start' }) });
      return;
    }
    const { dispatch, currentRoomInfo={} } = this.props;
    const {id = -1} = currentRoomInfo;
    let data = {
      id,
      startMaintainTime: moment(this.state.startMaintainTime).format("YYYY-MM-DD HH:mm"),
      endMaintainTime: moment(this.state.endMaintainTime).format("YYYY-MM-DD HH:mm"),
      maintainStatus: MAINTAIN_STATUS.not_start
    }
    const promise = new Promise((resolve, reject) => {
      dispatch({
        type: 'account/setRoomMaintain',
        resolve,
        reject,
        payload: data
      });
    });
    promise.then(
      () => {
        this.close();
      },
      msg => {
        Modal.error({ content: msg });
      }
    );
  };

  earlyEnd = () => {
    const { dispatch, currentRoomInfo={} } = this.props;
    const {id = -1} = currentRoomInfo;
    let data = {
      id,
      startMaintainTime: moment(this.state.startMaintainTime).format("YYYY-MM-DD HH:mm"),
      endMaintainTime: moment(this.state.endMaintainTime).format("YYYY-MM-DD HH:mm"),
      maintainStatus: MAINTAIN_STATUS.not_set
    }
    const promise = new Promise((resolve, reject) => {
      dispatch({
        type: 'account/setRoomMaintain',
        resolve,
        reject,
        payload: data
      });
    });
    promise.then(
      () => {
        this.close();
      },
      msg => {
        Modal.error({ content: msg });
      }
    );
  };
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n
  };
};

export default connect(mapStateToProps)(RoomMaintainModal);




// WEBPACK FOOTER //
// ./src/components/account/RoomMaintainModal.js